import React from "react";
import { FaTimes } from "react-icons/fa";

/**
 * Unified success banner used across all admin sub-pages.
 * Replaces the duplicated success message pattern that was
 * copy-pasted in AdminTeams, AdminClubs, AdminStadiums,
 * AdminMatches, and AdminEntries (each with its own CSS class).
 */
export const AdminSuccessBanner: React.FC<{
  message: string | null;
  onDismiss: () => void;
}> = ({ message, onDismiss }) => {
  if (!message) return null;
  return (
    <div className="admin-banner admin-banner--success">
      {message}
      <button onClick={onDismiss} className="admin-banner__close">
        <FaTimes />
      </button>
    </div>
  );
};

/**
 * Unified error banner used across admin sub-pages.
 * Replaces the inconsistent error display classes
 * (clubs-error, teams-error, matches-error, etc.).
 */
export const AdminErrorBanner: React.FC<{
  message: string | null;
}> = ({ message }) => {
  if (!message) return null;
  return (
    <div className="admin-banner admin-banner--error">
      {message}
    </div>
  );
};